export const de = {
  'chart-ng-common': {}
};
